<dx-popup [width]="900" [height]="150" [showTitle]="true" [dragEnabled]="true" [closeOnOutsideClick]="false"
  [(visible)]="okayCancelDialogVisible">
  <div *dxTemplate="let data of 'content'">
    <div>
        <p class="message" *ngIf="message">
            {{ message }}
        </p>
    </div>
    <div class="topmargin centerAlign">
      <div class="leftfloat">
        <dx-button class="ap-green-btn mr-1 mt-1 ml-2 px-5" text="Okay" (onClick)="OnOkayClicked()"></dx-button>
      </div>
      <div class="leftfloat">
        <dx-button class="ap-discard-button mr-1 mt-1 ml-2 px-5" text="Cancel" (onClick)="OnCancelClicked()">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>
